import React, { useEffect } from 'react';
import Layout from '../Layout/Layout';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Card from '@material-ui/core/Card';
import Chip from '@material-ui/core/Chip';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import { makeStyles, Typography, Fade } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import ConfigSelector from '../Home/ConfigSelector/ConfigSelector';
import Anuncio from '../Anuncio/Anuncio';
import Carousel from '../Carousel/Carousel';
import { proccessAdInfo, formatter } from '../../helpers';
import { useTheme } from '@material-ui/core/styles';
import { SelectorContext, ThemeCtx } from '../../context';
import LoginModal from '../LoginModal/LoginModal';
import { MetaTags } from 'react-meta-tags';

import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/scatter';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/effectScatter';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/markLine';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/legend';


const useStyles = makeStyles(theme => ({
    MainContainer : {
        marginTop: theme.spacing(4)
    },
    GraphContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    },
    SlidersWrapper: {        
        padding: '20px',        
        [theme.breakpoints.down('md')]: {
            width: '100%'
        }
    },
    Slider: {
        marginBottom: theme.spacing(10)
    },
    GraphWrapper : {
        width: '100%',
        padding: '20px',
        marginBottom: theme.spacing(10),
        [theme.breakpoints.down('md')] : {
            width: '100%'
        }
    },
    Graph: {
        height: '500px',
        // minWidth: '600px',
        // [theme.breakpoints.down('md')]: {
        //     overflowX: 'scroll'  
        // }
    },    
    Title: {
        fontWeight: 500,        
        display: 'block',
        width: '100%',   
        marginBottom: theme.spacing(2)     
    },  

    Bold  : {
        fontWeight: '500'
    },

    Subtitle: {
        fontWeight: 300,
        display: 'block',
        width: '100%',
        '& span' : {
            display: 'inline-flex',         
        },
        fontSize: '1rem',
        marginBottom: theme.spacing(2),
    },
    
    Caption: {        
        fontWeight: 100,
        marginBottom: theme.spacing(1),
        color: theme.palette.text.secondary,
        fontSize: '12px',
        textTransform: 'uppercase',
        display: 'flex',
        alignItems: 'center'
    },
    MetricsWrapper: {
        marginRight: '15px',       
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',                 
        marginTop: theme.spacing(1)
    },
    MetricWrapper: {
        width: '300px',
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1.3)
    },
    Metric: {
        fontSize: '20px',
        fontWeight: '500'       
    },
    MetricName: {
        fontWeight: '300',
        fontSize: '0.9rem',
        marginBottom: theme.spacing(.8),
        color: theme.palette.text.secondary,        
    },
    ModelResume : {
        marginBottom: theme.spacing(4),
        width: '100%'
    },
    Resume : {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap'           
    },
    StatsLine : {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(.2),        
    },
    StatsName : {
        textTransform: 'uppercase',
        fontSize: '11px',
        color: theme.palette.text.secondary
    },
    StatsValue : {
        fontSize: '14px',
        color: theme.palette.text.primary
    },
    DialogCloseBtn :  {
        position: 'absolute',
        right: '10px',
        top: '10px',
        color: '#fff'
    },
    DialogTitle : {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
    },
    TitleWrapper: {
        width: '100%'        
    },
    SubtitleWrapper : {
        display: 'block'
    },
    moreModelsChip : {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1.5)
    },
    Info: {        
        marginBottom: theme.spacing(4),
        maxWidth: '600px',
        color: '#9e9e9e'
    },
    sellNowText : {
        fontSize: '22px',
        lineHeight: '26px',
        fontWeight: 100,
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2)
    }
}))


export default withWidth()(function Detalle(props) {
    const classes = useStyles();       
    const [loading, setLoading] = React.useState(false);    
    const [scatter, setScatter] = React.useState({series: []})
    const [histogram, setHistogram] = React.useState({series: []})
    const [skeletonCount, setSkeletonCount] = React.useState(0);
    const [loginOpen, setLoginOpen] = React.useState(false);  
    const color = ['primary', 'secondary', 'terceary']
    const selectorCtx = React.useContext(SelectorContext);
    const themeCtx = React.useContext(ThemeCtx)
    const theme = useTheme();

    const [dialogOpen, setDialogOpen] = React.useState(false);    
    const [dialogContent, setDialogContent] = React.useState(null);
        
    
    function handleDialogOpen(dialogData) {
        setDialogOpen(true);
        setDialogContent({ ...dialogData });
    }

    function handleDialogClose() {
        setDialogOpen(false);
        setDialogContent(null)
    }

    const getHistogramData = (series) => {

        let globalMinPrice, globalMaxPrice, globalAdsCount, globalPriceRange, globalIntervalCount, globalIntervalAmplitude, seriesArray = [];
        
        globalMinPrice = Math.floor(series.reduce((min, s) => s.source.aggregations.price_stats.min < min ? s.source.aggregations.price_stats.min : min, parseInt(series[0].source.aggregations.price_stats.min)));
        
        globalMaxPrice = Math.ceil(series.reduce((max, s) => s.source.aggregations.price_stats.max > max ? s.source.aggregations.price_stats.max : max, parseInt(series[0].source.aggregations.price_stats.max)));

        globalAdsCount = series.reduce((sum, s) => sum += s.source.hits.total, 0);

        globalPriceRange = globalMaxPrice - globalMinPrice;
        globalIntervalCount = parseInt(Math.ceil(1 + 3.322 * Math.log(globalAdsCount)))
        globalIntervalAmplitude = parseInt(Math.ceil(globalPriceRange / globalIntervalCount).toFixed(0))
       
        series.forEach(serie => {            
            
            let histogramDataAux = [];
            let adsInRange;
    
            for (let index = 0; index < globalIntervalCount; index++) {
    
                let intervalMin = globalMinPrice + globalIntervalAmplitude * index;
                let intervalMax = intervalMin + globalIntervalAmplitude;
                let intervalMid = intervalMin + parseInt(Math.ceil((intervalMax - intervalMin) / 2))
                 
                // if last, increment intervalMax by 1 so values equals to maxPrice are considered
                if (index === globalIntervalCount - 1)
                    intervalMax += 1
                

                adsInRange = [...serie.source.hits.hits.filter(item => (parseInt(item['fields']['final_price_in_usd']) >= intervalMin && parseInt(item['fields']['final_price_in_usd']) < intervalMax))]            
                    
                histogramDataAux.push([
                    intervalMid,
                    adsInRange.length,
                    [...adsInRange],
                    intervalMin,
                    intervalMax                    
                ])                
            }

            let serieName = '', modObj = null;
            modObj = selectorCtx.modelo.length > 0 ? selectorCtx.modelo.find(m => m.id === parseInt(serie.mod)) : null;
            if (modObj)
                serieName = `${modObj.marca} ${modObj.name}`;

            seriesArray.push({ data: [...histogramDataAux], color: serie.color, name: serieName})
        });
       
        return {            
            min: globalMinPrice,
            max: globalMaxPrice,            
            iamplitude: globalIntervalAmplitude,
            icount: globalIntervalCount,
            series: [...seriesArray],            
        }
    }
        
    const [resumeMetricsComponent, setResumeMetricsComponent] = React.useState(null)
    
    const renderResumeMetrics = () => {
        let c = null;
        let auxCount = skeletonCount || 1;

        if (!loading) {
            c = selectorCtx.modelo.length > 0
                ? selectorCtx.modelo.slice().sort((modelA, modelB) => {
                    // sort alphabetically by brand and model
                    if (modelA.marca < modelB.marca) return -1;
                    if (modelA.marca > modelB.marca) return 1;
                    if (modelA.name < modelB.name) return - 1;
                    if (modelA.name > modelB.name) return - 1;
                    return 0;
                }).map((modelo, index) => {
                    let modSerie = scatter.series.find(s => s.mod === modelo.id)
                    return (
                        <Box key={'mod-' + index}>
                            {modSerie
                                ? <Box className={classes.ModelResume}>
                                    <Typography variant="caption" color="textSecondary" className={classes.Caption}><FiberManualRecordIcon fontSize="small" style={{ color: modSerie.color.main, marginRight: theme.spacing(1) }} />{modelo.marca} {modelo.name}
                                    </Typography>
                                    <Box className={classes.MetricsWrapper} key={'card-' + modelo.id}>
                                        {modSerie
                                            ? <React.Fragment>
                                                <Card className={classes.MetricWrapper}>
                                                    <div className={classes.MetricName}>Rango frecuente</div>
                                                    <Box className={classes.Metric}>
                                                        {`US$ ${formatter.format(parseInt(modSerie.stats.percentile25))}`} - {`US$ ${formatter.format(parseInt(modSerie.stats.percentile75))}`}
                                                    </Box>
                                                </Card>
                                                <Card className={classes.MetricWrapper}>
                                                    <div className={classes.MetricName}>+ Estadísticas</div>
                                                    <Box className={classes.StatsLine}>
                                                        <div className={classes.StatsName}>PROMEDIO</div>
                                                        <div className={classes.StatsValue}>{`US$ ${formatter.format(modSerie.stats.priceAvg)}`}</div>
                                                    </Box>
                                                    <Box className={classes.StatsLine}>
                                                        <div className={classes.StatsName}>PRECIO MINIMO</div>
                                                        <div className={classes.StatsValue}>{`US$ ${formatter.format(modSerie.stats.priceMin)}`}</div>
                                                    </Box>
                                                    <Box className={classes.StatsLine}>
                                                        <div className={classes.StatsName}>PRECIO MAXIMO</div>
                                                        <div className={classes.StatsValue}>{`US$ ${formatter.format(modSerie.stats.priceMax)}`}</div>
                                                    </Box>
                                                </Card>
                                            </React.Fragment>
                                            : null
                                        }
                                    </Box>
                                </Box>
                                : null
                            }
                        </Box>
                    )
                })
                : null  
        }
        else {
            let sks = [];
            for (let index = 0; index < auxCount; index++) {
                const element = (
                    <div key={`sk-block-${index}`}>
                        <Box className={classes.ModelResume}>
                            <Typography variant="caption" color="textSecondary" className={classes.Caption}>
                                <Skeleton variant="circle" width="15px" height="15px" style={{marginRight: '10px'}} />
                                <Skeleton animation="wave" width="200px" height="15px" />
                            </Typography>
                            <Box className={classes.MetricsWrapper} key={'card-sk-' + index}>
                        
                                <Card className={classes.MetricWrapper}>
                                    <Skeleton animation="wave" width="120px" height="15px" />
                                    <Box className={classes.Metric}>
                                        <Skeleton style={{marginTop: '5px'}} animation="wave" width="180px" height="30px" />
                                    </Box>
                                </Card>
                                <Card className={classes.MetricWrapper}>
                                    <Skeleton animation="wave" width="100px" height="25px" />
                                    <Box className={classes.StatsLine}>
                                        <Skeleton animation="wave" width="100px" height="15px" />
                                        <Skeleton animation="wave" width="50px" height="15px" />
                                    </Box>
                                    <Box className={classes.StatsLine}>
                                        <Skeleton animation="wave" width="150px" height="15px" />
                                        <Skeleton animation="wave" width="50px" height="15px" />                              
                                    </Box>
                                    <Box className={classes.StatsLine}>
                                        <Skeleton animation="wave" width="150px" height="15px" />
                                        <Skeleton animation="wave" width="50px" height="15px" />
                                    </Box>
                                   
                                </Card>
                            </Box>
                        </Box>
                    </div>
                );
                sks.push(element);
                
            }
            c = (<React.Fragment>
                { sks }
            </React.Fragment>)
        }
        setResumeMetricsComponent(c);
    }

    useEffect(()=> {        
        renderResumeMetrics();                    
    }, [scatter.series, loading])
     

    useEffect(() => {    
        window.scrollTo(0,0);            
        setLoading(true);        
        setScatter({series: []})
        setHistogram({series: []})

        // enviar GA a analytics.        
        
        let rubro2 = props.match.params.rubro2;        
        let modelosParams = props.match.params.modelosParams.split(',');        
        setSkeletonCount(modelosParams.length);     
        let G_USER_ID;   
        
        
        let nombresMarcas = [], nombresModelos = [];
        let fetchPromises = [];
        let dl = window.dataLayer;

        modelosParams.forEach((mod, index) => {  
            fetchPromises.push(new Promise((resolve, reject) => {
                fetch(`https://www.agroads.com.ar/precios/api/es.asp?action=anunciosActivos&maquinaria=${rubro2}&id_modelo=${mod}`)
                    .then(res => res.json())
                    .then(jsonRes => {
                        // calculateSeries  
                        if (jsonRes.userId != 0)
                        {                                            
                            G_USER_ID = parseInt(jsonRes.userId);
                        }
                                
                        if (jsonRes.hits && jsonRes.hits.hits && jsonRes.hits.hits.length > 0) {                            
                            nombresMarcas.push(jsonRes.hits.hits[0]['_source'].marca.detalle)
                            nombresModelos.push(jsonRes.hits.hits[0]['_source'].modelo.detalle)
                        }                    
                        let scatterDataAux = jsonRes.hits.hits.map(ad => {                        
                            return new Array(ad['_source']['año'], ad['fields']['final_price_in_usd'], parseInt(mod), parseInt(ad['_id']))
                        })                    
    
                        let scatterSerie = Object.assign({}, {
                            mod: parseInt(mod),
                            color: theme.palette[color[index]],
                            source: jsonRes,                    
                            echartsData: scatterDataAux.length > 0 ? scatterDataAux : [], 
                            adsCount: jsonRes.hits.total,   
                            year: {
                                min: jsonRes['aggregations']['year_stats']['min'],
                                max: jsonRes['aggregations']['year_stats']['max']
                            },
                            stats: {
                                percentile25: jsonRes['aggregations']['final_price_percentiles']['values']['25.0'],
                                percentile75: jsonRes['aggregations']['final_price_percentiles']['values']['75.0'],
                                priceAvg: parseInt(jsonRes['aggregations']['price_stats']['avg']),
                                priceMin: parseInt(jsonRes['aggregations']['price_stats']['min']),
                                priceMax: parseInt(jsonRes['aggregations']['price_stats']['max']),                   
                            }
                        });                    
    
                        let histogramSerie = Object.assign({}, {
                            mod: parseInt(mod),
                            color: theme.palette[color[index]],
                            source: jsonRes                        
                        });
    
                        // add new series                    
                        setScatter(prevScatter => ({ series: [...prevScatter.series, scatterSerie] }));
                        setHistogram(prevHistogram => ({ series: [...prevHistogram.series, histogramSerie] }));
                        resolve()
                    })
                    .catch(error => reject())
                    .finally(() => setLoading(false))
            }))                     
        })        
        
        Promise.all(fetchPromises).then(()=>{            
            if (process.env.NODE_ENV !== 'development') {
                // only prod                                               
                let rubroMapping = {
                    '10': 'Tractores',
                    '11': 'Cosechadoras',
                    '12': 'Sembradoras',
                    '13': 'Pulverizadoras'
                }
                let dlObj = {
                    'ruta': '/AgroadsPrecios/', //junto a event: 'pv', es la ruta que espera el activador para ejecutar la etiqueta de medicion de AgroadsPrecios
                    'titulo': 'Detalle-Precios',
                    'categoriaPagina': `Detalle-Precios/${rubroMapping[rubro2.toString()]}/`,
                    'event': 'pv',
                    'userId': G_USER_ID,
                };
                if (nombresMarcas.length > 0) {
                    let setMarcas = [...new Set(nombresMarcas)];
                    dlObj.marca = setMarcas.join(',');
                }

                if (nombresModelos.length > 0) {
                    let setModelos = [...new Set(nombresModelos)];
                    dlObj.modelo = setModelos.join(',');
                }                       
                dl.push(dlObj);   
            }     
        })
                
    }, [props.match.params]);    


    const getScatterOption = () => {
        let globalMin = 0, globalMax = 0;    
        
        let option = {      
            grid: {
                top: '20%',
                left: '2%',
                right: '10%',
                bottom: '10%',
                containLabel: true
            },
            legend: {
                data: [],
                left: '0'
            },
            dataZoom: [
                {
                    id: 'dataZoomY',
                    type: 'slider',
                    yAxisIndex: [0],
                    filterMode: 'empty',
                    zoomOnMouseWheel: true
                }                
            ],
            xAxis: {
                name: 'Año',
                type: 'value', 
                nameTextStyle: {
                    padding: [0, 0, 0, 20],
                    fontFamily: 'Roboto',
                    fontWeight: '500'
                },                       
                axisLabel: {
                    formatter: function (value, index) {
                        return `${formatter.format(value)}`
                    },
                    fontFamily: 'Roboto',
                    fontSize: '11',
                    fontWeight: '400',
                    rotate: isWidthUp('sm', props.width) ? 0 : 90
                },
                splitLine: {
                    lineStyle: {
                        color: '#f0f0f0'
                    }
                }
            },
            yAxis: {
                name: 'Precio',
                scale: true,
                nameTextStyle: { 
                    padding: [0, 0, 20, 0],                   
                    fontFamily: 'Roboto',
                    fontWeight: '500',
                    align: 'right'
                },        
                axisLabel: {
                    formatter: function (value, index) {
                        return `U$S ${formatter.format(value)}`
                    },
                    fontFamily: 'Roboto',
                    fontSize: '11',
                    fontWeight: '400'
                },
                splitLine: {
                    lineStyle: {
                        color: '#f0f0f0'
                    }
                }
            },
            series: []
        }
                
        // retrieve each scatter serie from state and add to series.
        let sortedSeries = scatter.series.slice().sort((a,b) => {
            if (a.stats.percentile25 < b.stats.percentile25) return 1;
            if (a.stats.percentile25 > b.stats.percentile25) return -1;
            return 0
        })        

        let modelLegends = [];
        sortedSeries.forEach(serie => {
            let serieName = '', modObj = null;
            modObj = selectorCtx.modelo.length > 0 ? selectorCtx.modelo.find(m => m.id === parseInt(serie.mod)) : null;            
            if (modObj)
                serieName = `${modObj.marca} ${modObj.name}`;

            // find out if url ad belongs to this serie, if does, add a markLine and a markPoint.

            // serie contains url ad?
            let adObjArray = null, scatterEffectData = [], effectScatterOpt = null;
            adObjArray = serie.echartsData.find(scatterDataArray => scatterDataArray[3] === parseInt(props.match.params.clasificadoid));
            if (adObjArray) {
                scatterEffectData = [...adObjArray];
                effectScatterOpt = {
                    type: 'effectScatter',
                    name: serieName,
                    symbolSize: 18,
                    itemStyle: {
                        color: serie.color.main
                    },
                    data: [
                        [...scatterEffectData]                        
                    ]
                }
            }


            let sAux = {
                type: 'scatter',
                name: serieName,
                symbolSize: 18,
                data: serie.echartsData.length > 0 ? [...serie.echartsData] : [],
                itemStyle: {
                    color: serie.color.main
                }
            }

            let sInfLimit = {
                
                label: {
                    show: false,
                    formatter: '{a}',
                    color: serie.color.dark
                },
                type: 'line',
                data: [
                    [0, serie.stats.percentile75], [new Date().getFullYear(), serie.stats.percentile75]
                ],
                lineStyle: {
                    color: serie.color.main,
                    type: 'dotted'
                },
                areaStyle: {
                    color: serie.color.main,
                    opacity: 0.15,
                },
                z: -1
            }

            let sSupLimit = {
                
                label: {
                    show: false,
                    formatter: '{a}',
                    color: serie.color.dark
                },
                type: 'line',
                data: [
                    [0, serie.stats.percentile25], [new Date().getFullYear(), serie.stats.percentile25]
                ],
                lineStyle: {
                    color: serie.color.main,
                    type: 'dotted'
                },
                areaStyle: {
                    color: '#fff',
                    opacity: 1,
                },
                z: -1
            }

            option.series.push(sInfLimit);
            option.series.push(sSupLimit);
            option.series.push(sAux);
            option.series.push(effectScatterOpt);
            modelLegends.push(serieName);
            
            if (globalMin === 0 || serie.year.min < globalMin)
                globalMin = serie.year.min
    
            if (globalMax === 0 || serie.year.max > globalMax)
                globalMax = serie.year.max

        });


        option.xAxis.min = globalMin - 2;
        option.xAxis.max = globalMax;
        option.xAxis.splitNumber = (globalMax - globalMin) / 2;
        option.legend.data = [...modelLegends.sort()]

        return option;
    }    
    const getHistogramOption = () => {
        let option = {   
            grid: {
                top: '20%',
                left: '2%',
                right: '10%',
                bottom: '10%',
                containLabel: true
            },   
            legend: {
                data: [],                
                left: '0'
            },
            xAxis: [{
                name: 'Precio',
                type: 'value',
                scale: true,
                clip: false,                
                boundaryGap: false,   
                nameTextStyle: {
                    padding: [0, 0, 0, 20],
                    fontFamily: 'Roboto',
                    fontWeight: '500'
                },                    
                splitLine: {
                    lineStyle: {
                        color: '#f0f0f0'
                    }
                },
                axisLabel: {
                    formatter: function (value, index) {
                        return `  U$S ${formatter.format(value.toFixed(0))}`
                    },
                    fontFamily: 'Roboto',
                    fontSize: '11',
                    fontWeight: '400',
                    rotate: isWidthUp('sm', props.width) ? 345 : 90              
                }, 
            }],
            yAxis: [{
                name: 'Cantidad',
                type: 'value',
                nameTextStyle: {                    
                    padding: [0,0,30,0],
                    fontFamily: 'Roboto',
                    fontWeight: '500'
                },  
                splitLine: {
                    lineStyle: {
                        color: '#f0f0f0'
                    }
                }                            
            }],
            series: []        
        }

        // get histogram data from each serie.source (jsonRes), considering globalValues in case there is more than one serie.
        let objHistogramData = getHistogramData(histogram.series.map(serie => serie));
        let modelLegends = [];

        // for each data array (serie), render a bar graph.
        objHistogramData.series.forEach((serie, index) => {
            let clasificadoMarkPoint = null;

            // find out if url ad belongs to this serie, if does, add a markLine and a markPoint.
            serie.data.forEach((dataArray, index) => {                     
                let objAux = dataArray[2].find(elem => parseInt(elem["_id"]) === parseInt(props.match.params.clasificadoid));
                if (objAux)
                    clasificadoMarkPoint = {...objAux, aboveTheMiddle : index > (serie.data.length / 2) }
            });
            
            
            let sAux = {
                type: 'bar',
                name: serie.name,
                barWidth: '98%',
                barGap: '-100%',                 
                data: serie.data.length > 0 ? serie.data : [],
                itemStyle: {
                    color: serie.color.main,
                    opacity: .9,                    
                }            
            }            

            if (clasificadoMarkPoint) {
                sAux = {
                    ...sAux,
                    markLine: {
                        label: {
                            show: false
                        },
                        symbol: 'none',
                        lineStyle: {
                            color: serie.color.main,
                            type: 'dotted',
                            opacity: 1,
                            width: 2,
                        },
                        data: [
                            {
                                name: 'Clasificado',
                                xAxis: parseInt(clasificadoMarkPoint.fields.final_price_in_usd),
                                ad: clasificadoMarkPoint
                            },
                        ]
                    },
                    markPoint: {
                        symbolSize: '30',
                        label: {
                            formatter: '{b}',
                            position: clasificadoMarkPoint.aboveTheMiddle ? 'left' : 'right'
                        },
                        itemStyle: {
                            color: serie.color.main
                        },
                        data: [
                            {
                                name: clasificadoMarkPoint["_source"].titulo,
                                xAxis: parseInt(clasificadoMarkPoint.fields.final_price_in_usd),                                                                
                                y: '20%', // relative to outter container of grid as grid has 20% paddingTop
                                ad: clasificadoMarkPoint
                            },
                        ]
                    }
                }                
            }

            modelLegends.push(serie.name);
            option.series.push(sAux);                 
        });



        // set axis configuration considering global values if needed.
        
        option.xAxis[0].min = objHistogramData.min;
        option.xAxis[0].max = objHistogramData.max;
        option.xAxis[0].interval = objHistogramData.iamplitude;
        option.legend.data = [...modelLegends.sort()];
            
        return option;
    }

    const onScatterClick = (param, echarts) => {        
        let srcData = scatter.series.find(s => s.mod === param.data[2]);        
        let ad = srcData.source.hits.hits.find(h => parseInt(h["_id"]) === param.data[3]); 
        let dialogContent = {
            title : '',
            subtitle : '',
            items: []            
        }        
        dialogContent.items.push(ad);

        // prevent tap propagation in mobile devices
        param.event.stop();
        handleDialogOpen(dialogContent);
    }

    const onHistogramClick = (param, echarts) => {                
        let dialogContent = {};
        if (param.componentType === 'markLine' || param.componentType === 'markPoint') {
            dialogContent.title = '';
            dialogContent.subtitle = '';
            dialogContent.items = [param.data.ad];         
        } else {
            dialogContent.title =  param.seriesName;
            dialogContent.subtitle = `Entre US$ ${formatter.format(param.data[3])} y US$ ${formatter.format(param.data[4])}`;
            dialogContent.items = [...param.data[2]]
        }            

        // prevent tap propagation in mobile devices
        param.event.stop();
        handleDialogOpen(dialogContent);          
    }
    
    let onScatterEvents = {
        'click': onScatterClick
    };

    let onHistogramEvents = {
        'click': onHistogramClick
    };    
    
    let pageTitle = "Precios de referencia"
    if (selectorCtx.modelo && selectorCtx.modelo.length > 0)
    {       
        pageTitle += ' - ' + selectorCtx.modelo.map(mod => `${mod.marca} ${mod.name}`).join(', ');                  
    }
    return (
        <Layout loading={loading} key={themeCtx.theme}>
            <MetaTags>
                <title>{ pageTitle }</title>
                <meta name="robots" content="noindex, nofollow" />            
            </MetaTags>                    
            <Container className={classes.MainContainer}>        
                <Box className={classes.ConfigWrapper}>                    
                    {/* <Box className={classes.Caption}>CONFIGURACION</Box>     */}
                    <ConfigSelector type="horizontal" />                    
                </Box>

                <Box className={classes.Resume}>
                    { resumeMetricsComponent }                   
                </Box>                

                <Box className={classes.GraphContainer}>

                    <Typography variant='h5' className={classes.Title}>Rango de precios</Typography>   
                    <Box className={classes.Info}>
                        <Fade in={true} timeout={{ appear: 500, enter: 2000, exit: 0 }}>
                            <div>
                                <Typography variant='body2'>Las estadísticas se obtienen a partir de los precios de la oferta actualmente activa en Agroads. Sin embargo, el valor real de un equipo puede variar dependiendo de su estado y horas de uso entre otros factores.</Typography>
                            </div>
                        </Fade>
                    </Box>                 
                    <Card className={classes.GraphWrapper}>
                        <Box className={classes.Graph}>
                            { histogram.series.length > 0
                                ? <ReactEchartsCore
                                    echarts={echarts}
                                    option={getHistogramOption()}
                                    onEvents={onHistogramEvents}
                                    notMerge={true}
                                    opts={{}}
                                    lazyUpdate={true}                                    
                                    style={{
                                        height: '100%',
                                        width: '100%',
                                    }} />
                                : null
                            }
                        </Box>
                    </Card>
                </Box>
                <Box className={classes.GraphContainer}>
                    <Typography variant='h5' className={classes.Title}>
                        Precios por año
                        <div className={classes.Subtitle}>
                            En base a <span className={classes.Bold}>{formatter.format(scatter.series.reduce((sum, current) => sum += current.adsCount, 0))}</span> anuncios
                        </div>
                    </Typography>                    
                    <Card className={classes.GraphWrapper}>
                        <Box className={classes.Graph}>
                            { scatter.series.length > 0 
                                ? <ReactEchartsCore
                                    echarts={echarts}
                                    option={getScatterOption()}
                                    onEvents={onScatterEvents}
                                    notMerge={true}
                                    lazyUpdate={true}    
                                    opts={{}}                                    
                                    style={{
                                        height: '100%',
                                        width: '100%',
                                    }}/>
                                : null 
                            }            
                        </Box>
                    </Card>
                </Box>
                <Box className={classes.SlidersWrapper}>
                    {
                        selectorCtx.modelo.length > 0 && scatter.series.length > 0 
                            ? scatter.series.map(serie => {
                                let title = '';
                                let link = '#';
                                let modAux = selectorCtx.modelo.find(mod => mod.id === parseInt(serie.mod))
                                if (modAux && modAux.marca && modAux.name) {
                                    title = `${modAux.marca} ${modAux.name}`;  
                                    let marAux = selectorCtx.marca.find(mar => mar.name === modAux.marca);
                                    if (marAux)
                                        link = `https://www.agroads.com.ar/seccion.asp?marca=${marAux.id}&subcat=${selectorCtx.rubro}&modelo=${modAux.id}`;                             
                                }
                                return (
                                    <div key={serie.mod} className={classes.Slider}>
                                        <Carousel title={title} action={{link: link, text: 'Ver más'}} items={serie.source.hits.hits}></Carousel>
                                    </div>
                                )
                            })
                            : null
                    }
                </Box>

                { selectorCtx && selectorCtx.modelo.length === 1
                    ? (
                        <Box className={classes.GraphWrapper}>
                            <Typography variant='h6'>
                                Publicá y vendé
                            </Typography>
                            <div className={classes.sellNowText}>
                                ¿Tenés un {`${selectorCtx.modelo[0].marca} ${selectorCtx.modelo[0].name}`} para vender?
                            </div>
                            <Button size="large" variant="outlined" color="primary" href={`https://www.agroads.com.ar/miembros/publicacion.asp?rubro1=2&rubro2=${selectorCtx.rubro}`}>Publicar gratis</Button>                            
                        </Box>
                    )
                    : null
                }

                { selectorCtx && selectorCtx.modelosOptions.length > 0 && selectorCtx.modelo.length < 3 && (!(selectorCtx.modelosOptions.length === 1 && selectorCtx.modelo[0].id === selectorCtx.modelosOptions[0].id)) 
                    ? (
                        <Box className={classes.GraphWrapper}>
                            <Typography variant='h5' className={classes.Title}>
                                Agregá otro modelo y compará los precios                       
                            </Typography>                              
                            {
                                selectorCtx.modelosOptions
                                    .filter(mod => !selectorCtx.modelo.find(m => m.id === mod.id))
                                    .map(model => < Chip className={classes.moreModelsChip} label={`${model.marca} ${model.name}`} component="a" href={`https://www.agroads.com.ar/precios/r/${props.match.params.rubro2}/modelos/${props.match.params.modelosParams},${model.id}/`} clickable variant="outlined" key={'chip-' + model.id }/> ) 
                            }
                        </Box>
                      )
                    : null
                }
            </Container>

            <Dialog open={dialogOpen} onClose={handleDialogClose} aria-labelledby="form-dialog-title">  
               <DialogTitle className={classes.DialogTitle} disableTypography>                    
                    { dialogContent && dialogContent.title 
                        ? <div className={classes.TitleWrapper}><Typography variant="h6">{dialogContent.title}</Typography></div>
                         : <React.Fragment>
                            <Icon fontSize="small" style={{ marginRight: theme.spacing(1) }}>offline_bolt</Icon>
                            <Typography variant="h6">Vista rápida</Typography>
                         </React.Fragment>
                    }
                    { dialogContent && dialogContent.subtitle
                        ?
                        <div className={classes.SubtitleWrapper}>
                            <Typography variant="caption">{dialogContent.subtitle}</Typography>
                        </div> 
                        : null
                    }
                </DialogTitle>                  
                                      
                <DialogContent>
                    { dialogContent && dialogContent.items && dialogContent.items.length > 0
                        ? dialogContent.items.length === 1
                            ? <Anuncio variant="outlined" content={proccessAdInfo(dialogContent.items[0])} />
                            : <div className={classes.Slider}>
                                <Carousel title={''} itemSlideCount={3} itemVariant="outlined" items={dialogContent.items}></Carousel>
                             </div>
                        : null
                    }
                </DialogContent>        
                <DialogActions>   
                    <Button color="primary" onClick={handleDialogClose}>Cerrar</Button>                
                    { dialogContent && dialogContent.items.length === 1 
                        ? <Button onClick={handleDialogClose} variant="outlined" color="primary" target="_blank" href={ dialogContent ? `https://www.agroads.com.ar/detalle.asp?clasi=${dialogContent.items[0]["_id"]}` : ''}>
                            Ver detalle
                        </Button>
                        : null
                    }
                </DialogActions>
            </Dialog>
            <LoginModal isOpen={loginOpen} />            
        </Layout>
    )
})
